import { Flex } from '@chakra-ui/react';
import { FC, PropsWithChildren } from 'react';

export const DatePickerHeader: FC<PropsWithChildren> = ({ children }) => (
  <Flex as="header" w="100%" justifyContent="space-between" alignItems="center">
    {children}
  </Flex>
);
